module.exports = "pegasus/assets/tech/email1-bg3.png";